if (typeof document === "undefined") return;
var createStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject
) {
	var linkTag = document.createElement("link");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;

	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var findStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var loadStylesheet = function (chunkId) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	"index": 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises) {
	var cssChunks = {
"managed-apps_business-coach_frontend_App_js": 1,
"managed-apps_business-coach_frontend_pages_admin_AdminRoutes_tsx-shared_platform_frontend_com-11c6cc": 1,
"managed-apps_business-coach_frontend_pages_agents_AgentGridPage_tsx-shared_platform_frontend_-9cd039": 1,
"managed-apps_business-coach_frontend_pages_artifacts_ArtifactsPage_tsx-shared_platform_fronte-7c69d4": 1,
"managed-apps_business-coach_frontend_pages_chat_AgentChatPage_jsx-shared_platform_frontend_co-a74ec0": 1,
"managed-apps_business-coach_frontend_pages_journal_JournalPage_tsx-shared_platform_frontend_h-8f9b3c": 1,
"managed-apps_business-coach_frontend_pages_tasks_TasksPage_tsx-shared_platform_frontend_compo-44833e": 1,
"managed-apps_business-coach_frontend_pages_widget-dashboard_WidgetDashboardPage_tsx-shared_pl-c73a35": 1,
"managed-apps_meet-at-the-mirror_frontend_App_js-shared_platform_frontend_components_app_sideb-ff4352": 1,
"managed-apps_meet-at-the-mirror_frontend_pages_admin_AdminRoutes_js-shared_components_SharedT-b8e8c2": 1,
"managed-apps_meet-at-the-mirror_frontend_pages_cards_CardsWithAudio_js-shared_node_modules_nc-7fde3e": 1,
"managed-apps_meet-at-the-mirror_frontend_pages_chat_ChatsPage_js-shared_components_SharedToas-f7db48": 1,
"managed-apps_meet-at-the-mirror_frontend_pages_matchmaking-vsl_MatchmakingVslPage_js": 1,
"node_modules_lucide-react_dist_esm_icons_calendar-plus_js-node_modules_lucide-react_dist_esm_-631d2e": 1,
"node_modules_lucide-react_dist_esm_icons_loader-circle_js-shared_components_SharedToast_js-sh-237b0a": 1,
"shared_node_modules_moment_locale_sync_recursive_-src_pages_valet_stands_StandIndexPage_js-no-ce325e": 1,
"src_App_js-src_components_useFormHelper_js": 1,
"src_pages_rides_index_js-node_modules_shortcut-buttons-flatpickr_dist_themes_light_min_css": 1,
"src_pages_valet_admin_announcements_index_js-node_modules_intro_js_introjs_css-node_modules_s-8d7f40": 1,
"src_utils_tailwindConfigData_js-managed-apps_meet-at-the-mirror_frontend_pages_events_host_Ho-326b77": 1,
"src_utils_useWindowOrientation_js-managed-apps_meet-at-the-mirror_frontend_pages_events_Event-82ab2d": 1,
"vendors-node_modules_capacitor_app_dist_esm_index_js-node_modules_capacitor_splash-screen_dis-6bf1fc": 1,
"vendors-node_modules_xyflow_react_dist_style_css-node_modules_xyflow_react_dist_esm_index_js--49a4b4": 1,
"vendors-shared_node_modules_katex_dist_katex_min_css-node_modules_lucide-react_dist_esm_icons-cbc0ed": 1,
"vendors-shared_node_modules_react-toastify_dist_ReactToastify_min_css": 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = loadStylesheet(chunkId).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

var oldTags = [];
var newTags = [];
var applyHandler = function (options) {
	return {
		dispose: function () {
			for (var i = 0; i < oldTags.length; i++) {
				var oldTag = oldTags[i];
				if (oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
			}
			oldTags.length = 0;
		},
		apply: function () {
			for (var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
			newTags.length = 0;
		}
	}
}
__webpack_require__.hmrC.miniCss = function (chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function (chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if (!oldTag) return;
		promises.push(new Promise(function (resolve, reject) {
			var tag = createStylesheet(
				chunkId,

				/**
					If dynamically add link tag through dom API and there is already a loaded style link, browsers sometimes treats the new link tag as the same link, and won't fetch the new style.
					Use query to avoid browser cache the link tag, force to re-fetch new style, this is the same strategy as updateCss API, this can happen during lazy compilation
				 */
				`${fullhref}?${Date.now()}`,
				oldTag,
				function () {
					tag.as = "style";
					tag.rel = "preload";
					resolve();
				},
				reject
			);
			oldTags.push(oldTag);
			newTags.push(tag);
		}))
	});
}

// no prefetch
// no preload